import { useCallback } from "react";
import { useCommand } from "@lookiero/messaging-react";
import { updateUiSetting } from "../../../../domain/uiSetting/command/updateUiSetting";
const useUpdateUiSetting = ({ contextId, logger }) => {
    const [commandBus, status] = useCommand({ contextId });
    const update = useCallback(async ({ aggregateId, key, value }) => {
        try {
            await commandBus(updateUiSetting({
                aggregateId,
                key,
                value,
            }));
        }
        catch (error) {
            logger.captureException(error);
        }
    }, [commandBus, logger]);
    return [update, status];
};
export { useUpdateUiSetting };
